    
<template>
    <div id="books" class="container">
      <div class="section-title">كُتُـــب</div>
      <ul>
        <!-- <li class="book" v-for="book in books" :key="book.id">
          <img :src="'https://cms.zaidounk.com/'+book.bookCover" alt="">
          <div class="title-date">
            <div class="title">{{book.bookName}}</div>
            <span class="date">{{book.bookDate}}</span>
          </div>
          <div class="body" v-html="book.bookDescription"></div>
        </li> -->
        <li class="book">
          <img :src="'https://cms.zaidounk.com/'+books[0].bookCover" alt="">
          <div class="title-date">
            <div class="title">{{books[0].bookName}}</div>
            <span class="date">{{books[0].bookDate}}</span>
          </div>
          <div class="body" v-html="books[0].bookDescription"></div>
          <a href="http://www.japublishers.com/%D9%84%D8%B3%D9%87-%D9%81%D9%8A/" target="_blank" class="order-1">دار نشر جبل عمّان</a>
          <a href="http://jamalon.com/ar/catalog/product/view/id/35110857" target="_blank" class="order-2">طلب الكتاب/ جملون</a>
        </li>
        <li class="book">
          <img :src="'https://cms.zaidounk.com/'+books[1].bookCover" alt="">
          <div class="title-date">
            <div class="title">{{books[1].bookName}}</div>
            <span class="date">{{books[1].bookDate}}</span>
          </div>
          <div class="body"><div v-html="books[1].bookDescription"></div><p>هذي هي فكرة مبدئية من <span @click="openedPopup = !openedPopup">صفحة واحدة</span></p></div>
          <div class="popup" v-if="openedPopup">
            <div class="popup-overlay" @click="openedPopup = !openedPopup"></div>
            <!-- <div class="popup-content">
              <i class="fa fa-times close" aria-hidden="true" @click="openedPopup = !openedPopup"></i>
              <img src='https://cms.zaidounk.com/book2-screenshot.jpg'>
            </div> -->
              <img src='https://cms.zaidounk.com/book2-screenshot.jpg'>
          </div>
        </li>
        
      </ul>
    </div>
</template>

<script>
export default {
  data () {
      return {
        books: '',
        openedPopup: false
      }
  },
  methods: {
  },
  created () {
    this.$http.get('https://cms.zaidounk.com/api/books')
    .then(result => {
      return result.json()
    })
    .then(data => {
      this.books = data
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/sections/Books.vue